import Vue from "vue";
import {
  Button,
  Icon,
  Layout,
  Row,
  Col,
  Steps,
  PageHeader,
  AutoComplete,
  Checkbox,
  DatePicker,
  Form,
  FormModel,
  Input,
  InputNumber,
  Radio,
  Select,
  Slider,
  Switch,
  Upload,
  Badge,
  Card,
  Descriptions,
  Empty,
  List,
  Popover,
  Tabs,
  Timeline,
  Tooltip,
  Alert,
  Drawer,
  Modal,
  Progress,
  Result,
  Spin,
  Anchor,
  BackTop,
  Divider,
  message,
  notification
} from "ant-design-vue";

// General
Vue.component(Button.name, Button);
Vue.component(Button.Group.name, Button.Group);
Vue.component(Icon.name, Icon);

// Layout
const { Content, Header, Footer, Sider } = Layout;

Vue.component(Layout.name, Layout);

Vue.component(Content.name, Content);
Vue.component(Header.name, Header);
Vue.component(Footer.name, Footer);
Vue.component(Sider.name, Sider);

Vue.component(Row.name, Row);
Vue.component(Col.name, Col);

// Navigation
Vue.component(Steps.name, Steps);
Vue.component(Steps.Step.name, Steps.Step);
Vue.component(PageHeader.name, PageHeader);

// Data Entry
const CheckboxGroup = Checkbox.Group;
const { MonthPicker, RangePicker } = DatePicker;
const FormItem = Form.Item;
const FormModelItem = FormModel.Item;
const InputGroup = Input.Group;
const InputSearch = Input.Search;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

Vue.component(AutoComplete.name, AutoComplete);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(DatePicker.name, DatePicker);
Vue.component(MonthPicker.name, MonthPicker);
Vue.component(RangePicker.name, RangePicker);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(FormModel.name, FormModel);
Vue.component(FormModelItem.name, FormModelItem);
Vue.component(Input.name, Input);
Vue.component(InputGroup.name, InputGroup);
Vue.component(InputSearch.name, InputSearch);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Slider.name, Slider);
Vue.component(Switch.name, Switch);
Vue.component(Upload.name, Upload);
Vue.component(Upload.Dragger.name, Upload.Dragger);

// Data Display
const CardGrid = Card.Grid;
const CardMeta = Card.Meta;
const DescriptionsItem = Descriptions.Item;
const ListItem = List.Item;
const ListItemMeta = List.Item.Meta;
const TabsTabPane = Tabs.TabPane;
const TimelineItem = Timeline.Item;

Vue.component(Badge.name, Badge);
Vue.component(Card.name, Card);
Vue.component(CardGrid.name, CardGrid);
Vue.component(CardMeta.name, CardMeta);
Vue.component(Descriptions.name, Descriptions);
Vue.component(DescriptionsItem.name, DescriptionsItem);
Vue.component(Empty.name, Empty);
Vue.component(List.name, List);
Vue.component(ListItem.name, ListItem);
Vue.component(ListItemMeta.name, ListItemMeta);
Vue.component(Popover.name, Popover);
Vue.component(Tabs.name, Tabs);
Vue.component(TabsTabPane.name, TabsTabPane);
Vue.component(Timeline.name, Timeline);
Vue.component(TimelineItem.name, TimelineItem);
Vue.component(Tooltip.name, Tooltip);

// Feedback
Vue.component(Alert.name, Alert);
Vue.component(Drawer.name, Drawer);
Vue.use(Modal); // Failed to resolve directive: ant-portal
Vue.component(Modal.name, Modal);
Vue.component(Progress.name, Progress);
Vue.component(Result.name, Result);
Vue.component(Spin.name, Spin);

// Other
const AnchorLink = Anchor.Link;

Vue.component(Anchor.name, Anchor);
Vue.component(AnchorLink.name, AnchorLink);
Vue.component(BackTop.name, BackTop);
Vue.component(Divider.name, Divider);

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
